<template>
  <div class="my-2" style="max-width: 700px">
    <v-layout row wrap>
      <v-flex
        v-for="(day, index) in days"
        :key="index"
      >
        <v-checkbox
          v-model="selected"
          :label="day"
          :value="index"
          hide-details
          class="py-2"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: [ 'value' ],
  watch: {
    value () {
      this.updating = true
      this.selected = []
      if (typeof this.value === 'string') {
        for (let i = 0; i < this.value.length; i++) {
          if (this.value.charAt(i) === 'Y') {
            this.selected.push(i)
          }
        }
      }
      this.updating = false
    },
    selected () {
      if (this.updating) return

      let value = this.days.reduce((value, day, index) => {
        if (this.selected.indexOf(index) >= 0) return value + 'Y'
        return value + 'N'
      }, '')
      this.$emit('input', value)
    }
  },
  data () {
    let selected = []
    if (typeof this.value === 'string') {
      for (let i = 0; i < this.value.length; i++) {
        if (this.value.charAt(i) === 'Y') {
          selected.push(i)
        }
      }
    }

    return {
      updating: false,
      selected,
      days: [
        this.$t('week.monday'),
        this.$t('week.tuesday'),
        this.$t('week.wednesday'),
        this.$t('week.thursday'),
        this.$t('week.friday'),
        this.$t('week.saturday'),
        this.$t('week.sunday')
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Weekdays.vue?3c922dc4